import { utm } from "@segment/analytics-next/dist/cjs/plugins/segmentio/normalize";
import { useEffect, useState } from "react";
import { useMount } from "react-use";

import { useAuth } from "lib/features/auth";
import { UserRole } from "lib/types";

// loads HubSpot scripts to track UTM if user is not student
// given that script could load after we modify the URL, immediately save UTM path if UTM is detected
// to ensure that we send UTM tracking to HubSpot
export const useNonStudentHubspotTracking = (): void => {
  const { authUser } = useAuth();
  const [utmPath, setUtmPath] = useState("");

  useMount(() => {
    const urlUtmData = utm(window.location.href);
    if (Object.keys(urlUtmData).length > 0) {
      setUtmPath(window.location.pathname + window.location.search);
    }
  });

  useEffect(() => {
    if (
      authUser &&
      authUser.role !== UserRole.Student &&
      authUser.role !== UserRole.Uninitialized
    ) {
      const hsScriptExists = document.getElementById("hs-script");
      if (!hsScriptExists) {
        const hsScript = document.createElement("script");
        hsScript.id = "hs-script";
        hsScript.src =
          "https://js.hs-scripts.com/5258344.js?businessUnitId=357883";
        hsScript.async = true;
        hsScript.onload = () => {
          setTimeout(() => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const hubspot = window._hsq;
            const currentPath =
              window.location.pathname + window.location.search;
            if (hubspot && utmPath && utmPath != currentPath) {
              hubspot.push(["setPath", utmPath]);
              hubspot.push(["trackPageView"]);
            }
          }, 250);
        };

        document.body.appendChild(hsScript);
      }
    }
  }, [authUser, utmPath]);
};
